/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * Represents an adjustment made to an employees leave allowance for a given period.
 * @export
 * @interface LeaveAdjustment
 */
export interface LeaveAdjustment {
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    employeeId: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    leavePeriodId: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    leaveTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    adjusterId: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAdjustment
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof LeaveAdjustment
     */
    baseLeaveAllowanceUnit: LeaveAdjustmentBaseLeaveAllowanceUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaveAdjustment
     */
    reason: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LeaveAdjustment
     */
    createdAt: Date;
    /**
     * 
     * @type {Employee}
     * @memberof LeaveAdjustment
     */
    employee?: Employee;
    /**
     * 
     * @type {Employee}
     * @memberof LeaveAdjustment
     */
    adjuster?: Employee;
}

/**
* @export
* @enum {string}
*/
export enum LeaveAdjustmentBaseLeaveAllowanceUnitEnum {
    Days = 'Days',
    Hours = 'Hours'
}


/**
 * Check if a given object implements the LeaveAdjustment interface.
 */
export function instanceOfLeaveAdjustment(value: object): value is LeaveAdjustment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('leavePeriodId' in value) || value['leavePeriodId'] === undefined) return false;
    if (!('leaveTypeId' in value) || value['leaveTypeId'] === undefined) return false;
    if (!('adjusterId' in value) || value['adjusterId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('baseLeaveAllowanceUnit' in value) || value['baseLeaveAllowanceUnit'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function LeaveAdjustmentFromJSON(json: any): LeaveAdjustment {
    return LeaveAdjustmentFromJSONTyped(json, false);
}

export function LeaveAdjustmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveAdjustment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'leavePeriodId': json['leavePeriodId'],
        'leaveTypeId': json['leaveTypeId'],
        'adjusterId': json['adjusterId'],
        'amount': json['amount'],
        'baseLeaveAllowanceUnit': json['baseLeaveAllowanceUnit'],
        'reason': json['reason'],
        'createdAt': (new Date(json['createdAt'])),
        'employee': json['employee'] == null ? undefined : EmployeeFromJSON(json['employee']),
        'adjuster': json['adjuster'] == null ? undefined : EmployeeFromJSON(json['adjuster']),
    };
}

  export function LeaveAdjustmentToJSON(json: any): LeaveAdjustment {
      return LeaveAdjustmentToJSONTyped(json, false);
  }

  export function LeaveAdjustmentToJSONTyped(value?: LeaveAdjustment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'leavePeriodId': value['leavePeriodId'],
        'leaveTypeId': value['leaveTypeId'],
        'adjusterId': value['adjusterId'],
        'amount': value['amount'],
        'baseLeaveAllowanceUnit': value['baseLeaveAllowanceUnit'],
        'reason': value['reason'],
        'createdAt': ((value['createdAt']).toISOString()),
        'employee': EmployeeToJSON(value['employee']),
        'adjuster': EmployeeToJSON(value['adjuster']),
    };
}

